export const GET_EVENT_PLANNING_REQUEST = "GET_EVENT_PLANNING_REQUEST";
export const SET_EVENT_PLANNING = "SET_EVENT_PLANNING";
export const EVENT_PLANNING_LOADING = "EVENT_PLANNING_LOADING";
